var render = function render(){var _vm=this,_c=_vm._self._c;return _c('perfect-scrollbar',{staticClass:"card container-card mt-5 mt-md-0"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }